import TableHeaderCell from "../common/table/tableHeaderCell"
import { t } from "i18next";

const TableHeader = () => {

  return (
    <thead>
      <tr >
        <TableHeaderCell className="regionalCodeWidth" label={t('regional-code')} />
        <TableHeaderCell label={t('name-agenda')} />
      </tr>
    </thead>
  )
}

export default TableHeader